import './PlaygroundMessageLoader.css';

export const PlaygroundMessageLoader = () => {
  return (
    <div className={'min-w-10 flex items-center justify-center'}>
      <span className={'playground-message-loader'}></span>
    </div>
  );
};
